var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGameFormation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 759,
    height: 466.658,
    viewBox: "0 0 759 466.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17880",
    "data-name": "Group 17880",
    transform: "translate(12826 12998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17868",
    "data-name": "Group 17868",
    transform: "translate(-13260 -13380.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-user-single",
    transform: "translate(787.181 382.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262",
    "data-name": "Ellipse 262",
    cx: 13.759,
    cy: 13.759,
    r: 13.759,
    transform: "translate(13.224 0.5)",
    fill: "#0782c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569",
    "data-name": "Path 10569",
    d: "M53.146,28.077a27.476,27.476,0,0,0-52.326,0Z",
    transform: "translate(0 27.459)",
    fill: "#0782c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17495",
    "data-name": "Group 17495",
    transform: "translate(-7.805 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_10590",
    "data-name": "Path 10590",
    transform: "translate(749.805 448)",
    fill: "#0d82cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 123 40.5 L 21 40.5 C 18.36685943603516 40.5 15.81328010559082 39.98463821411133 13.41018009185791 38.96820068359375 C 11.08831977844238 37.98614120483398 9.002739906311035 36.57992172241211 7.211420059204102 34.78858184814453 C 5.420080184936523 32.99726104736328 4.01386022567749 30.91168022155762 3.031800031661987 28.58982086181641 C 2.015360116958618 26.18671989440918 1.5 23.63314056396484 1.5 21 C 1.5 18.36685943603516 2.015360116958618 15.81328010559082 3.031800031661987 13.41018009185791 C 4.01386022567749 11.08831977844238 5.420080184936523 9.002739906311035 7.211420059204102 7.211420059204102 C 9.002739906311035 5.420080184936523 11.08831977844238 4.01386022567749 13.41018009185791 3.031800031661987 C 15.81328010559082 2.015360116958618 18.36685943603516 1.5 21 1.5 L 123 1.5 C 125.6331405639648 1.5 128.1867218017578 2.015360116958618 130.5898132324219 3.031800031661987 C 132.9116821289062 4.01386022567749 134.9972534179688 5.420080184936523 136.78857421875 7.211420059204102 C 138.5799255371094 9.002739906311035 139.9861450195312 11.08831977844238 140.9682006835938 13.41018009185791 C 141.9846343994141 15.81328010559082 142.5 18.36685943603516 142.5 21 C 142.5 23.63314056396484 141.9846343994141 26.18671989440918 140.9682006835938 28.58982086181641 C 139.9861450195312 30.91168022155762 138.5799255371094 32.99726104736328 136.78857421875 34.78858184814453 C 134.9972534179688 36.57992172241211 132.9116821289062 37.98614120483398 130.5898132324219 38.96820068359375 C 128.1867218017578 39.98463821411133 125.6331405639648 40.5 123 40.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 3 C 16.19202423095703 3 11.67182922363281 4.872333526611328 8.272079467773438 8.272083282470703 C 4.872329711914062 11.67183303833008 3 16.19202041625977 3 21 C 3 25.80797958374023 4.872329711914062 30.32816696166992 8.272079467773438 33.7279167175293 C 11.67182922363281 37.12766647338867 16.19202423095703 39 21 39 L 123 39 C 127.8079833984375 39 132.3281707763672 37.12766647338867 135.7279205322266 33.7279167175293 C 139.1276702880859 30.32816696166992 141 25.80797958374023 141 21 C 141 16.19202041625977 139.1276702880859 11.67183303833008 135.7279205322266 8.272083282470703 C 132.3281707763672 4.872333526611328 127.8079833984375 3 123 3 L 21 3 M 21 0 L 123 0 C 134.5979766845703 0 144 9.402019500732422 144 21 C 144 32.59798049926758 134.5979766845703 42 123 42 L 21 42 C 9.402023315429688 42 0 32.59798049926758 0 21 C 0 9.402019500732422 9.402023315429688 0 21 0 Z",
    stroke: "none",
    fill: "#001a38"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10920",
    "data-name": "Path 10920",
    d: "M-48.874.183a4.9,4.9,0,0,1-3.677-1.465,5.3,5.3,0,0,1-1.421-3.831,5.666,5.666,0,0,1,1.443-4.028,4.981,4.981,0,0,1,3.823-1.538,4.755,4.755,0,0,1,3.633,1.472,5.4,5.4,0,0,1,1.392,3.882,5.567,5.567,0,0,1-1.443,3.992q-.051.051-.1.1a1.131,1.131,0,0,1-.1.092l2.659,2.556h-3.311L-47.358,0A5.892,5.892,0,0,1-48.874.183Zm.1-8.826a2.391,2.391,0,0,0-1.978.938,3.878,3.878,0,0,0-.732,2.468,3.822,3.822,0,0,0,.732,2.468,2.347,2.347,0,0,0,1.919.908,2.374,2.374,0,0,0,1.941-.879,3.814,3.814,0,0,0,.718-2.454,4.116,4.116,0,0,0-.7-2.542A2.256,2.256,0,0,0-48.771-8.643Zm15.546,4.094q0,4.731-4.409,4.731-4.277,0-4.277-4.622V-10.5h2.373v6.094q0,2.549,1.992,2.549,1.956,0,1.956-2.461V-10.5h2.366ZM-21.884,0h-2.578l-.747-2.336h-3.735L-29.685,0h-2.563l3.823-10.5h2.805Zm-3.867-4.153-1.128-3.53a4.6,4.6,0,0,1-.176-.945h-.059a4.006,4.006,0,0,1-.183.916l-1.143,3.56ZM-11.612,0H-14.33l-1.633-2.7q-.183-.308-.352-.549a3.052,3.052,0,0,0-.341-.414,1.354,1.354,0,0,0-.359-.264.911.911,0,0,0-.406-.092h-.637V0h-2.366V-10.5h3.75q3.823,0,3.823,2.856a2.958,2.958,0,0,1-.168,1.014,2.818,2.818,0,0,1-.476.839,3.018,3.018,0,0,1-.743.645,3.834,3.834,0,0,1-.97.425v.029a1.505,1.505,0,0,1,.454.238,3.252,3.252,0,0,1,.425.385,5.365,5.365,0,0,1,.392.472q.187.253.341.494Zm-6.445-8.73v2.922h1.025a1.7,1.7,0,0,0,1.223-.439,1.467,1.467,0,0,0,.469-1.106q0-1.377-1.648-1.377Zm14.652.154h-3V0H-8.774V-8.577h-2.981V-10.5h8.35ZM4.457,0h-6.3V-10.5H4.215v1.926H.524V-6.24H3.959v1.919H.524v2.4H4.457ZM15.1,0H12.385L10.752-2.7q-.183-.308-.352-.549a3.052,3.052,0,0,0-.341-.414A1.354,1.354,0,0,0,9.7-3.929a.911.911,0,0,0-.406-.092H8.657V0H6.291V-10.5h3.75q3.823,0,3.823,2.856A2.958,2.958,0,0,1,13.7-6.632a2.818,2.818,0,0,1-.476.839,3.018,3.018,0,0,1-.743.645,3.834,3.834,0,0,1-.97.425v.029a1.505,1.505,0,0,1,.454.238,3.252,3.252,0,0,1,.425.385,5.365,5.365,0,0,1,.392.472q.187.253.341.494ZM8.657-8.73v2.922H9.682a1.7,1.7,0,0,0,1.223-.439,1.467,1.467,0,0,0,.469-1.106q0-1.377-1.648-1.377ZM16.234,0V-10.5h3.823a4.774,4.774,0,0,1,2.7.645A2.073,2.073,0,0,1,23.7-8.042a2.15,2.15,0,0,1-.575,1.487,3.021,3.021,0,0,1-1.469.886v.029a2.91,2.91,0,0,1,1.791.828,2.315,2.315,0,0,1,.67,1.677A2.8,2.8,0,0,1,23.089-.846,4.321,4.321,0,0,1,20.269,0ZM18.6-8.76v2.49h1.04a1.733,1.733,0,0,0,1.154-.355,1.211,1.211,0,0,0,.421-.978q0-1.157-1.729-1.157Zm0,4.248v2.769h1.282a1.973,1.973,0,0,0,1.285-.381,1.272,1.272,0,0,0,.465-1.04,1.187,1.187,0,0,0-.458-.989A2.025,2.025,0,0,0,19.9-4.512ZM35.236,0H32.658l-.747-2.336H28.176L27.436,0H24.873L28.7-10.5H31.5ZM31.369-4.153l-1.128-3.53a4.6,4.6,0,0,1-.176-.945h-.059a4.006,4.006,0,0,1-.183.916l-1.143,3.56ZM44-.374a6.926,6.926,0,0,1-3,.557,5.062,5.062,0,0,1-3.8-1.421,5.194,5.194,0,0,1-1.384-3.787,5.549,5.549,0,0,1,1.556-4.087,5.444,5.444,0,0,1,4.039-1.567A7.554,7.554,0,0,1,44-10.291v2.278a4.594,4.594,0,0,0-2.4-.63,3.187,3.187,0,0,0-2.388.93,3.451,3.451,0,0,0-.908,2.52,3.385,3.385,0,0,0,.857,2.428,3.027,3.027,0,0,0,2.307.9A4.921,4.921,0,0,0,44-2.534ZM54.711,0H51.723L48.661-4.563a4.374,4.374,0,0,1-.278-.579h-.037V0H45.981V-10.5h2.366v4.966h.037q.088-.205.293-.586l2.9-4.38H54.4l-3.662,5.01Z",
    transform: "translate(821.805 476)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17869",
    "data-name": "Group 17869",
    transform: "translate(-13260.5 -13235.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-user-single-2",
    "data-name": "interface-user-single",
    transform: "translate(787.181 382.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262-2",
    "data-name": "Ellipse 262",
    cx: 13.759,
    cy: 13.759,
    r: 13.759,
    transform: "translate(13.224 0.5)",
    fill: "#0782c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569-2",
    "data-name": "Path 10569",
    d: "M53.146,28.077a27.476,27.476,0,0,0-52.326,0Z",
    transform: "translate(0 27.459)",
    fill: "#0782c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17495-2",
    "data-name": "Group 17495",
    transform: "translate(-7.805 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1871",
    "data-name": "Rectangle 1871",
    transform: "translate(749.805 448)",
    fill: "#0782c6",
    stroke: "#001a38",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 42,
    rx: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 141,
    height: 39,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10917",
    "data-name": "Path 10917",
    d: "M-41.289-10.5-44.065,0h-2.622l-1.743-6.738A5.619,5.619,0,0,1-48.6-7.917h-.029a7.164,7.164,0,0,1-.19,1.179L-50.606,0h-2.732L-56.1-10.5h2.585l1.479,6.995a8.35,8.35,0,0,1,.139,1.2h.044a5.814,5.814,0,0,1,.212-1.23l1.9-6.965H-47.2l1.721,7.053a8.637,8.637,0,0,1,.168,1.128h.029a7.562,7.562,0,0,1,.154-1.172l1.45-7.009ZM-37.441,0h-2.366V-10.5h2.366ZM-34.9,0V-10.5h3.721q5.6,0,5.6,5.12a5.177,5.177,0,0,1-1.527,3.918A5.631,5.631,0,0,1-31.182,0Zm2.366-8.577v6.658h1.172a3.167,3.167,0,0,0,2.413-.923,3.5,3.5,0,0,0,.875-2.512,3.177,3.177,0,0,0-.868-2.362,3.309,3.309,0,0,0-2.435-.861ZM-17.395,0h-6.3V-10.5h6.057v1.926h-3.691V-6.24h3.435v1.919h-3.435v2.4h3.933ZM-2.461,0H-5.178L-6.811-2.7q-.183-.308-.352-.549A3.052,3.052,0,0,0-7.5-3.666a1.354,1.354,0,0,0-.359-.264.911.911,0,0,0-.406-.092h-.637V0h-2.366V-10.5h3.75Q-3.7-10.5-3.7-7.646a2.958,2.958,0,0,1-.168,1.014,2.818,2.818,0,0,1-.476.839,3.018,3.018,0,0,1-.743.645,3.834,3.834,0,0,1-.97.425v.029a1.505,1.505,0,0,1,.454.238,3.252,3.252,0,0,1,.425.385,5.365,5.365,0,0,1,.392.472q.187.253.341.494ZM-8.906-8.73v2.922h1.025a1.7,1.7,0,0,0,1.223-.439,1.467,1.467,0,0,0,.469-1.106q0-1.377-1.648-1.377ZM4.969,0h-6.3V-10.5H4.728v1.926H1.036V-6.24H4.471v1.919H1.036v2.4H4.969Zm9.364-.374a6.926,6.926,0,0,1-3,.557,5.062,5.062,0,0,1-3.8-1.421A5.194,5.194,0,0,1,6.145-5.024,5.549,5.549,0,0,1,7.7-9.111a5.444,5.444,0,0,1,4.039-1.567,7.554,7.554,0,0,1,2.593.388v2.278a4.594,4.594,0,0,0-2.4-.63,3.187,3.187,0,0,0-2.388.93,3.451,3.451,0,0,0-.908,2.52,3.385,3.385,0,0,0,.857,2.428,3.027,3.027,0,0,0,2.307.9,4.921,4.921,0,0,0,2.534-.674ZM22.613,0h-6.3V-10.5h6.057v1.926H18.68V-6.24h3.435v1.919H18.68v2.4h3.933Zm4.2,0H24.448V-10.5h2.366ZM38.1-10.5,34.478,0H31.8L28.223-10.5h2.549l2.19,7.31a5.235,5.235,0,0,1,.212,1.047h.044a5.92,5.92,0,0,1,.227-1.077l2.175-7.28ZM45.8,0h-6.3V-10.5h6.057v1.926H41.872V-6.24h3.435v1.919H41.872v2.4H45.8ZM56.451,0H53.733L52.1-2.7q-.183-.308-.352-.549a3.052,3.052,0,0,0-.341-.414,1.354,1.354,0,0,0-.359-.264.911.911,0,0,0-.406-.092h-.637V0H47.64V-10.5h3.75q3.823,0,3.823,2.856a2.958,2.958,0,0,1-.168,1.014,2.818,2.818,0,0,1-.476.839,3.018,3.018,0,0,1-.743.645,3.834,3.834,0,0,1-.97.425v.029a1.505,1.505,0,0,1,.454.238,3.252,3.252,0,0,1,.425.385,5.365,5.365,0,0,1,.392.472q.187.253.341.494ZM50.005-8.73v2.922h1.025a1.7,1.7,0,0,0,1.223-.439,1.467,1.467,0,0,0,.469-1.106q0-1.377-1.648-1.377Z",
    transform: "translate(821.805 476)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17870",
    "data-name": "Group 17870",
    transform: "translate(-12953 -13235.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-user-single-3",
    "data-name": "interface-user-single",
    transform: "translate(787.181 382.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262-3",
    "data-name": "Ellipse 262",
    cx: 13.759,
    cy: 13.759,
    r: 13.759,
    transform: "translate(13.224 0.5)",
    fill: "#0782c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569-3",
    "data-name": "Path 10569",
    d: "M53.146,28.077a27.476,27.476,0,0,0-52.326,0Z",
    transform: "translate(0 27.459)",
    fill: "#0782c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17495-3",
    "data-name": "Group 17495",
    transform: "translate(-7.805 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1871-2",
    "data-name": "Rectangle 1871",
    transform: "translate(749.805 448)",
    fill: "#0782c6",
    stroke: "#001a38",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 42,
    rx: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 141,
    height: 39,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10916",
    "data-name": "Path 10916",
    d: "M-41.289-10.5-44.065,0h-2.622l-1.743-6.738A5.619,5.619,0,0,1-48.6-7.917h-.029a7.164,7.164,0,0,1-.19,1.179L-50.606,0h-2.732L-56.1-10.5h2.585l1.479,6.995a8.35,8.35,0,0,1,.139,1.2h.044a5.814,5.814,0,0,1,.212-1.23l1.9-6.965H-47.2l1.721,7.053a8.637,8.637,0,0,1,.168,1.128h.029a7.562,7.562,0,0,1,.154-1.172l1.45-7.009ZM-37.441,0h-2.366V-10.5h2.366ZM-34.9,0V-10.5h3.721q5.6,0,5.6,5.12a5.177,5.177,0,0,1-1.527,3.918A5.631,5.631,0,0,1-31.182,0Zm2.366-8.577v6.658h1.172a3.167,3.167,0,0,0,2.413-.923,3.5,3.5,0,0,0,.875-2.512,3.177,3.177,0,0,0-.868-2.362,3.309,3.309,0,0,0-2.435-.861ZM-17.395,0h-6.3V-10.5h6.057v1.926h-3.691V-6.24h3.435v1.919h-3.435v2.4h3.933ZM-2.461,0H-5.178L-6.811-2.7q-.183-.308-.352-.549A3.052,3.052,0,0,0-7.5-3.666a1.354,1.354,0,0,0-.359-.264.911.911,0,0,0-.406-.092h-.637V0h-2.366V-10.5h3.75Q-3.7-10.5-3.7-7.646a2.958,2.958,0,0,1-.168,1.014,2.818,2.818,0,0,1-.476.839,3.018,3.018,0,0,1-.743.645,3.834,3.834,0,0,1-.97.425v.029a1.505,1.505,0,0,1,.454.238,3.252,3.252,0,0,1,.425.385,5.365,5.365,0,0,1,.392.472q.187.253.341.494ZM-8.906-8.73v2.922h1.025a1.7,1.7,0,0,0,1.223-.439,1.467,1.467,0,0,0,.469-1.106q0-1.377-1.648-1.377ZM4.969,0h-6.3V-10.5H4.728v1.926H1.036V-6.24H4.471v1.919H1.036v2.4H4.969Zm9.364-.374a6.926,6.926,0,0,1-3,.557,5.062,5.062,0,0,1-3.8-1.421A5.194,5.194,0,0,1,6.145-5.024,5.549,5.549,0,0,1,7.7-9.111a5.444,5.444,0,0,1,4.039-1.567,7.554,7.554,0,0,1,2.593.388v2.278a4.594,4.594,0,0,0-2.4-.63,3.187,3.187,0,0,0-2.388.93,3.451,3.451,0,0,0-.908,2.52,3.385,3.385,0,0,0,.857,2.428,3.027,3.027,0,0,0,2.307.9,4.921,4.921,0,0,0,2.534-.674ZM22.613,0h-6.3V-10.5h6.057v1.926H18.68V-6.24h3.435v1.919H18.68v2.4h3.933Zm4.2,0H24.448V-10.5h2.366ZM38.1-10.5,34.478,0H31.8L28.223-10.5h2.549l2.19,7.31a5.235,5.235,0,0,1,.212,1.047h.044a5.92,5.92,0,0,1,.227-1.077l2.175-7.28ZM45.8,0h-6.3V-10.5h6.057v1.926H41.872V-6.24h3.435v1.919H41.872v2.4H45.8ZM56.451,0H53.733L52.1-2.7q-.183-.308-.352-.549a3.052,3.052,0,0,0-.341-.414,1.354,1.354,0,0,0-.359-.264.911.911,0,0,0-.406-.092h-.637V0H47.64V-10.5h3.75q3.823,0,3.823,2.856a2.958,2.958,0,0,1-.168,1.014,2.818,2.818,0,0,1-.476.839,3.018,3.018,0,0,1-.743.645,3.834,3.834,0,0,1-.97.425v.029a1.505,1.505,0,0,1,.454.238,3.252,3.252,0,0,1,.425.385,5.365,5.365,0,0,1,.392.472q.187.253.341.494ZM50.005-8.73v2.922h1.025a1.7,1.7,0,0,0,1.223-.439,1.467,1.467,0,0,0,.469-1.106q0-1.377-1.648-1.377Z",
    transform: "translate(821.805 476)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17871",
    "data-name": "Group 17871",
    transform: "translate(-13568 -13235.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-user-single-4",
    "data-name": "interface-user-single",
    transform: "translate(787.181 382.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262-4",
    "data-name": "Ellipse 262",
    cx: 13.759,
    cy: 13.759,
    r: 13.759,
    transform: "translate(13.224 0.5)",
    fill: "#0782c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569-4",
    "data-name": "Path 10569",
    d: "M53.146,28.077a27.476,27.476,0,0,0-52.326,0Z",
    transform: "translate(0 27.459)",
    fill: "#0782c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17495-4",
    "data-name": "Group 17495",
    transform: "translate(-7.805 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1871-3",
    "data-name": "Rectangle 1871",
    transform: "translate(749.805 448)",
    fill: "#0782c6",
    stroke: "#001a38",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 42,
    rx: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 141,
    height: 39,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10918",
    "data-name": "Path 10918",
    d: "M-41.289-10.5-44.065,0h-2.622l-1.743-6.738A5.619,5.619,0,0,1-48.6-7.917h-.029a7.164,7.164,0,0,1-.19,1.179L-50.606,0h-2.732L-56.1-10.5h2.585l1.479,6.995a8.35,8.35,0,0,1,.139,1.2h.044a5.814,5.814,0,0,1,.212-1.23l1.9-6.965H-47.2l1.721,7.053a8.637,8.637,0,0,1,.168,1.128h.029a7.562,7.562,0,0,1,.154-1.172l1.45-7.009ZM-37.441,0h-2.366V-10.5h2.366ZM-34.9,0V-10.5h3.721q5.6,0,5.6,5.12a5.177,5.177,0,0,1-1.527,3.918A5.631,5.631,0,0,1-31.182,0Zm2.366-8.577v6.658h1.172a3.167,3.167,0,0,0,2.413-.923,3.5,3.5,0,0,0,.875-2.512,3.177,3.177,0,0,0-.868-2.362,3.309,3.309,0,0,0-2.435-.861ZM-17.395,0h-6.3V-10.5h6.057v1.926h-3.691V-6.24h3.435v1.919h-3.435v2.4h3.933ZM-2.461,0H-5.178L-6.811-2.7q-.183-.308-.352-.549A3.052,3.052,0,0,0-7.5-3.666a1.354,1.354,0,0,0-.359-.264.911.911,0,0,0-.406-.092h-.637V0h-2.366V-10.5h3.75Q-3.7-10.5-3.7-7.646a2.958,2.958,0,0,1-.168,1.014,2.818,2.818,0,0,1-.476.839,3.018,3.018,0,0,1-.743.645,3.834,3.834,0,0,1-.97.425v.029a1.505,1.505,0,0,1,.454.238,3.252,3.252,0,0,1,.425.385,5.365,5.365,0,0,1,.392.472q.187.253.341.494ZM-8.906-8.73v2.922h1.025a1.7,1.7,0,0,0,1.223-.439,1.467,1.467,0,0,0,.469-1.106q0-1.377-1.648-1.377ZM4.969,0h-6.3V-10.5H4.728v1.926H1.036V-6.24H4.471v1.919H1.036v2.4H4.969Zm9.364-.374a6.926,6.926,0,0,1-3,.557,5.062,5.062,0,0,1-3.8-1.421A5.194,5.194,0,0,1,6.145-5.024,5.549,5.549,0,0,1,7.7-9.111a5.444,5.444,0,0,1,4.039-1.567,7.554,7.554,0,0,1,2.593.388v2.278a4.594,4.594,0,0,0-2.4-.63,3.187,3.187,0,0,0-2.388.93,3.451,3.451,0,0,0-.908,2.52,3.385,3.385,0,0,0,.857,2.428,3.027,3.027,0,0,0,2.307.9,4.921,4.921,0,0,0,2.534-.674ZM22.613,0h-6.3V-10.5h6.057v1.926H18.68V-6.24h3.435v1.919H18.68v2.4h3.933Zm4.2,0H24.448V-10.5h2.366ZM38.1-10.5,34.478,0H31.8L28.223-10.5h2.549l2.19,7.31a5.235,5.235,0,0,1,.212,1.047h.044a5.92,5.92,0,0,1,.227-1.077l2.175-7.28ZM45.8,0h-6.3V-10.5h6.057v1.926H41.872V-6.24h3.435v1.919H41.872v2.4H45.8ZM56.451,0H53.733L52.1-2.7q-.183-.308-.352-.549a3.052,3.052,0,0,0-.341-.414,1.354,1.354,0,0,0-.359-.264.911.911,0,0,0-.406-.092h-.637V0H47.64V-10.5h3.75q3.823,0,3.823,2.856a2.958,2.958,0,0,1-.168,1.014,2.818,2.818,0,0,1-.476.839,3.018,3.018,0,0,1-.743.645,3.834,3.834,0,0,1-.97.425v.029a1.505,1.505,0,0,1,.454.238,3.252,3.252,0,0,1,.425.385,5.365,5.365,0,0,1,.392.472q.187.253.341.494ZM50.005-8.73v2.922h1.025a1.7,1.7,0,0,0,1.223-.439,1.467,1.467,0,0,0,.469-1.106q0-1.377-1.648-1.377Z",
    transform: "translate(821.805 476)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17872",
    "data-name": "Group 17872",
    transform: "translate(-13424 -13331.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-user-single-5",
    "data-name": "interface-user-single",
    transform: "translate(787.181 382.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262-5",
    "data-name": "Ellipse 262",
    cx: 13.759,
    cy: 13.759,
    r: 13.759,
    transform: "translate(13.224 0.5)",
    fill: "#0782c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569-5",
    "data-name": "Path 10569",
    d: "M53.146,28.077a27.476,27.476,0,0,0-52.326,0Z",
    transform: "translate(0 27.459)",
    fill: "#0782c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17495-5",
    "data-name": "Group 17495",
    transform: "translate(-7.805 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1871-4",
    "data-name": "Rectangle 1871",
    transform: "translate(749.805 448)",
    fill: "#0782c6",
    stroke: "#001a38",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 42,
    rx: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 141,
    height: 39,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10919",
    "data-name": "Path 10919",
    d: "M-48.2,0h-2.717l-1.633-2.7q-.183-.308-.352-.549a3.052,3.052,0,0,0-.341-.414,1.354,1.354,0,0,0-.359-.264.911.911,0,0,0-.406-.092h-.637V0h-2.366V-10.5h3.75q3.823,0,3.823,2.856a2.958,2.958,0,0,1-.168,1.014,2.818,2.818,0,0,1-.476.839,3.018,3.018,0,0,1-.743.645,3.834,3.834,0,0,1-.97.425v.029a1.505,1.505,0,0,1,.454.238,3.252,3.252,0,0,1,.425.385,5.365,5.365,0,0,1,.392.472q.187.253.341.494Zm-6.445-8.73v2.922h1.025A1.7,1.7,0,0,0-52.4-6.248a1.467,1.467,0,0,0,.469-1.106q0-1.377-1.648-1.377Zm16.139,4.182q0,4.731-4.409,4.731-4.277,0-4.277-4.622V-10.5h2.373v6.094q0,2.549,1.992,2.549,1.956,0,1.956-2.461V-10.5h2.366ZM-26.625,0h-2.388l-4.329-6.6a9.543,9.543,0,0,1-.527-.872H-33.9q.059.557.059,1.7V0h-2.234V-10.5h2.549l4.167,6.394q.286.432.527.857h.029a11.23,11.23,0,0,1-.059-1.443V-10.5h2.234Zm12,0h-2.388l-4.329-6.6a9.543,9.543,0,0,1-.527-.872H-21.9q.059.557.059,1.7V0h-2.234V-10.5h2.549l4.167,6.394q.286.432.527.857h.029a11.23,11.23,0,0,1-.059-1.443V-10.5h2.234Zm4.918,0h-2.366V-10.5h2.366ZM2.28,0H-.108L-4.437-6.6a9.543,9.543,0,0,1-.527-.872h-.029q.059.557.059,1.7V0H-7.169V-10.5H-4.62L-.452-4.109q.286.432.527.857H.1A11.23,11.23,0,0,1,.046-4.695V-10.5H2.28ZM13.453-.7A7.559,7.559,0,0,1,9.629.183a5.529,5.529,0,0,1-4-1.4A5.1,5.1,0,0,1,4.173-5.083a5.394,5.394,0,0,1,1.6-4.036,5.817,5.817,0,0,1,4.248-1.56,8.629,8.629,0,0,1,2.944.461V-8a5.852,5.852,0,0,0-2.974-.7,3.192,3.192,0,0,0-2.4.956,3.511,3.511,0,0,0-.927,2.552,3.522,3.522,0,0,0,.831,2.5A2.93,2.93,0,0,0,9.739-1.8a3.125,3.125,0,0,0,1.348-.242V-4.094h-2.1v-1.89h4.468Zm6.482.7V-10.5h3.823a4.774,4.774,0,0,1,2.7.645,2.073,2.073,0,0,1,.945,1.816,2.15,2.15,0,0,1-.575,1.487,3.021,3.021,0,0,1-1.469.886v.029a2.91,2.91,0,0,1,1.791.828,2.315,2.315,0,0,1,.67,1.677A2.8,2.8,0,0,1,26.79-.846,4.321,4.321,0,0,1,23.97,0ZM22.3-8.76v2.49h1.04a1.733,1.733,0,0,0,1.154-.355,1.211,1.211,0,0,0,.421-.978q0-1.157-1.729-1.157Zm0,4.248v2.769h1.282a1.973,1.973,0,0,0,1.285-.381,1.272,1.272,0,0,0,.465-1.04,1.187,1.187,0,0,0-.458-.989A2.025,2.025,0,0,0,23.6-4.512ZM38.937,0H36.359l-.747-2.336H31.876L31.137,0H28.573L32.4-10.5H35.2ZM35.07-4.153l-1.128-3.53a4.6,4.6,0,0,1-.176-.945h-.059a4.006,4.006,0,0,1-.183.916l-1.143,3.56ZM47.7-.374a6.926,6.926,0,0,1-3,.557,5.062,5.062,0,0,1-3.8-1.421,5.194,5.194,0,0,1-1.384-3.787,5.549,5.549,0,0,1,1.556-4.087,5.444,5.444,0,0,1,4.039-1.567,7.554,7.554,0,0,1,2.593.388v2.278a4.594,4.594,0,0,0-2.4-.63,3.187,3.187,0,0,0-2.388.93A3.451,3.451,0,0,0,42-5.193a3.385,3.385,0,0,0,.857,2.428,3.027,3.027,0,0,0,2.307.9A4.921,4.921,0,0,0,47.7-2.534ZM58.412,0H55.423L52.362-4.563a4.374,4.374,0,0,1-.278-.579h-.037V0H49.681V-10.5h2.366v4.966h.037q.088-.205.293-.586l2.9-4.38H58.1l-3.662,5.01Z",
    transform: "translate(821.805 476)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17873",
    "data-name": "Group 17873",
    transform: "translate(-13424 -13138.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-user-single-6",
    "data-name": "interface-user-single",
    transform: "translate(787.181 382.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262-6",
    "data-name": "Ellipse 262",
    cx: 13.759,
    cy: 13.759,
    r: 13.759,
    transform: "translate(13.224 0.5)",
    fill: "#0782c6",
    stroke: "#054f77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569-6",
    "data-name": "Path 10569",
    d: "M53.146,28.077a27.476,27.476,0,0,0-52.326,0Z",
    transform: "translate(0 27.459)",
    fill: "#0782c6",
    stroke: "#054f77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17495-6",
    "data-name": "Group 17495",
    transform: "translate(-7.805 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1871-5",
    "data-name": "Rectangle 1871",
    transform: "translate(749.805 448)",
    fill: "#0782c6",
    stroke: "#001a38",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 42,
    rx: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 141,
    height: 39,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17877",
    "data-name": "Group 17877"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10915",
    "data-name": "Path 10915",
    d: "M-31.783-8.577h-3V0h-2.373V-8.577h-2.981V-10.5h8.35ZM-27.854,0h-2.366V-10.5h2.366ZM-16.7-.7a7.559,7.559,0,0,1-3.823.886,5.529,5.529,0,0,1-4-1.4,5.1,5.1,0,0,1-1.461-3.864,5.394,5.394,0,0,1,1.6-4.036,5.817,5.817,0,0,1,4.248-1.56,8.629,8.629,0,0,1,2.944.461V-8a5.852,5.852,0,0,0-2.974-.7,3.192,3.192,0,0,0-2.4.956,3.511,3.511,0,0,0-.927,2.552,3.522,3.522,0,0,0,.831,2.5,2.93,2.93,0,0,0,2.245.886,3.125,3.125,0,0,0,1.348-.242V-4.094h-2.1v-1.89H-16.7ZM-5.412,0H-7.786V-4.277h-4.351V0H-14.5V-10.5h2.366v4.189h4.351V-10.5h2.373ZM4.515-8.577h-3V0H-.853V-8.577H-3.834V-10.5h8.35ZM16.666,0h-6.3V-10.5h6.057v1.926H12.733V-6.24h3.435v1.919H12.733v2.4h3.933ZM27.949,0H25.561L21.232-6.6a9.543,9.543,0,0,1-.527-.872h-.029q.059.557.059,1.7V0H18.5V-10.5h2.549l4.167,6.394q.286.432.527.857h.029a11.23,11.23,0,0,1-.059-1.443V-10.5h2.234ZM30.5,0V-10.5h3.721q5.6,0,5.6,5.12A5.177,5.177,0,0,1,38.29-1.465,5.631,5.631,0,0,1,34.222,0Zm2.366-8.577v6.658h1.172a3.167,3.167,0,0,0,2.413-.923,3.5,3.5,0,0,0,.875-2.512,3.177,3.177,0,0,0-.868-2.362,3.309,3.309,0,0,0-2.435-.861Z",
    transform: "translate(821.805 476)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17874",
    "data-name": "Group 17874",
    transform: "translate(-13424 -13011.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-user-single-7",
    "data-name": "interface-user-single",
    transform: "translate(787.181 382.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262-7",
    "data-name": "Ellipse 262",
    cx: 13.759,
    cy: 13.759,
    r: 13.759,
    transform: "translate(13.224 0.5)",
    fill: "#0782c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569-7",
    "data-name": "Path 10569",
    d: "M53.146,28.077a27.476,27.476,0,0,0-52.326,0Z",
    transform: "translate(0 27.459)",
    fill: "#0782c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17495-7",
    "data-name": "Group 17495",
    transform: "translate(-7.805 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1871-6",
    "data-name": "Rectangle 1871",
    transform: "translate(749.805 448)",
    fill: "#0782c6",
    stroke: "#001a38",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 42,
    rx: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 141,
    height: 39,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10912",
    "data-name": "Path 10912",
    d: "M-16.122,0H-19.11l-3.062-4.563a4.374,4.374,0,0,1-.278-.579h-.037V0h-2.366V-10.5h2.366v4.966h.037q.088-.205.293-.586l2.9-4.38h2.82L-20.1-5.493ZM-12.6,0h-2.366V-10.5H-12.6ZM-2.536-.374a6.926,6.926,0,0,1-3,.557,5.062,5.062,0,0,1-3.8-1.421,5.194,5.194,0,0,1-1.384-3.787A5.549,5.549,0,0,1-9.168-9.111a5.444,5.444,0,0,1,4.039-1.567,7.554,7.554,0,0,1,2.593.388v2.278a4.594,4.594,0,0,0-2.4-.63,3.187,3.187,0,0,0-2.388.93,3.451,3.451,0,0,0-.908,2.52,3.385,3.385,0,0,0,.857,2.428,3.027,3.027,0,0,0,2.307.9,4.921,4.921,0,0,0,2.534-.674ZM8.176,0H5.187L2.126-4.563a4.374,4.374,0,0,1-.278-.579H1.811V0H-.555V-10.5H1.811v4.966h.037q.088-.205.293-.586l2.9-4.38h2.82L4.2-5.493Zm7.452,0h-6.3V-10.5h6.057v1.926H11.695V-6.24H15.13v1.919H11.695v2.4h3.933ZM26.273,0H23.556L21.923-2.7q-.183-.308-.352-.549a3.052,3.052,0,0,0-.341-.414,1.354,1.354,0,0,0-.359-.264.911.911,0,0,0-.406-.092h-.637V0H17.462V-10.5h3.75q3.823,0,3.823,2.856a2.958,2.958,0,0,1-.168,1.014,2.818,2.818,0,0,1-.476.839,3.018,3.018,0,0,1-.743.645,3.834,3.834,0,0,1-.97.425v.029a1.505,1.505,0,0,1,.454.238,3.252,3.252,0,0,1,.425.385,5.365,5.365,0,0,1,.392.472q.187.253.341.494ZM19.828-8.73v2.922h1.025a1.7,1.7,0,0,0,1.223-.439,1.467,1.467,0,0,0,.469-1.106q0-1.377-1.648-1.377Z",
    transform: "translate(821.805 476)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17875",
    "data-name": "Group 17875",
    transform: "translate(-13096 -13138.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-user-single-8",
    "data-name": "interface-user-single",
    transform: "translate(787.181 382.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262-8",
    "data-name": "Ellipse 262",
    cx: 13.759,
    cy: 13.759,
    r: 13.759,
    transform: "translate(13.224 0.5)",
    fill: "#0782c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569-8",
    "data-name": "Path 10569",
    d: "M53.146,28.077a27.476,27.476,0,0,0-52.326,0Z",
    transform: "translate(0 27.459)",
    fill: "#0782c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17495-8",
    "data-name": "Group 17495",
    transform: "translate(-7.805 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1871-7",
    "data-name": "Rectangle 1871",
    transform: "translate(749.805 448)",
    fill: "#0782c6",
    stroke: "#001a38",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 42,
    rx: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 141,
    height: 39,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10914",
    "data-name": "Path 10914",
    d: "M-39.092-8.577H-42.8V-6h3.406V-4.08H-42.8V0h-2.366V-10.5h6.072ZM-30.959,0h-6.255V-10.5h2.366v8.584h3.889ZM-23.1,0h-6.3V-10.5h6.057v1.926H-27.03V-6.24h3.435v1.919H-27.03v2.4H-23.1Zm10.712,0H-15.19L-17-3.42a3,3,0,0,1-.212-.7h-.029a5.323,5.323,0,0,1-.242.732L-19.3,0h-2.82l3.347-5.251L-21.833-10.5h2.878l1.5,3.149a5.442,5.442,0,0,1,.315.886h.029q.088-.308.33-.916l1.67-3.12h2.637L-15.622-5.3Zm8.056-3.618V0H-6.694V-10.5h3.706q3.97,0,3.97,3.347A3.212,3.212,0,0,1-.157-4.6,4.512,4.512,0,0,1-3.2-3.618Zm0-5.068v3.274h.93q1.89,0,1.89-1.655,0-1.619-1.89-1.619ZM8.924,0H2.67V-10.5H5.035v8.584H8.924ZM20.053,0H17.475l-.747-2.336H12.993L12.253,0H9.69l3.823-10.5h2.805ZM16.186-4.153l-1.128-3.53a4.6,4.6,0,0,1-.176-.945h-.059a4.006,4.006,0,0,1-.183.916L13.5-4.153ZM28.3-10.5l-3.42,6.768V0H22.518V-3.691L19.185-10.5h2.7L23.58-6.584q.044.11.242.857h.029a3.816,3.816,0,0,1,.227-.828L25.8-10.5ZM35.939,0h-6.3V-10.5H35.7v1.926H32.006V-6.24h3.435v1.919H32.006v2.4h3.933ZM46.585,0H43.868L42.234-2.7q-.183-.308-.352-.549a3.052,3.052,0,0,0-.341-.414,1.354,1.354,0,0,0-.359-.264.911.911,0,0,0-.406-.092H40.14V0H37.774V-10.5h3.75q3.823,0,3.823,2.856a2.958,2.958,0,0,1-.168,1.014,2.818,2.818,0,0,1-.476.839,3.018,3.018,0,0,1-.743.645,3.834,3.834,0,0,1-.97.425v.029a1.505,1.505,0,0,1,.454.238,3.252,3.252,0,0,1,.425.385,5.365,5.365,0,0,1,.392.472q.187.253.341.494ZM40.14-8.73v2.922h1.025a1.7,1.7,0,0,0,1.223-.439,1.467,1.467,0,0,0,.469-1.106q0-1.377-1.648-1.377Z",
    transform: "translate(821.805 476)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17876",
    "data-name": "Group 17876",
    transform: "translate(-13096 -13011.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-user-single-9",
    "data-name": "interface-user-single",
    transform: "translate(787.181 382.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262-9",
    "data-name": "Ellipse 262",
    cx: 13.759,
    cy: 13.759,
    r: 13.759,
    transform: "translate(13.224 0.5)",
    fill: "#0782c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569-9",
    "data-name": "Path 10569",
    d: "M53.146,28.077a27.476,27.476,0,0,0-52.326,0Z",
    transform: "translate(0 27.459)",
    fill: "#0782c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17495-9",
    "data-name": "Group 17495",
    transform: "translate(-7.805 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1871-8",
    "data-name": "Rectangle 1871",
    transform: "translate(749.805 448)",
    fill: "#0782c6",
    stroke: "#001a38",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 42,
    rx: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 141,
    height: 39,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10913",
    "data-name": "Path 10913",
    d: "M-13.077,0V-10.5h3.721q5.6,0,5.6,5.12A5.177,5.177,0,0,1-5.288-1.465,5.631,5.631,0,0,1-9.357,0Zm2.366-8.577v6.658H-9.54a3.167,3.167,0,0,0,2.413-.923,3.5,3.5,0,0,0,.875-2.512,3.177,3.177,0,0,0-.868-2.362,3.309,3.309,0,0,0-2.435-.861ZM-2.351-.4V-2.747a4.5,4.5,0,0,0,1.384.8,4.45,4.45,0,0,0,1.509.267,3.346,3.346,0,0,0,.78-.081,1.827,1.827,0,0,0,.557-.223.974.974,0,0,0,.333-.337.841.841,0,0,0,.11-.421.91.91,0,0,0-.176-.549,1.892,1.892,0,0,0-.48-.447,5.013,5.013,0,0,0-.721-.4q-.417-.19-.9-.388A4.6,4.6,0,0,1-1.791-5.771a2.734,2.734,0,0,1-.6-1.787,2.846,2.846,0,0,1,.33-1.41,2.8,2.8,0,0,1,.9-.97A4.023,4.023,0,0,1,.146-10.5a6.755,6.755,0,0,1,1.582-.179,9.515,9.515,0,0,1,1.454.1,5.718,5.718,0,0,1,1.168.3v2.19a3.532,3.532,0,0,0-.575-.322,4.555,4.555,0,0,0-.641-.231,4.888,4.888,0,0,0-.656-.135,4.639,4.639,0,0,0-.619-.044,3.228,3.228,0,0,0-.732.077,1.879,1.879,0,0,0-.557.216,1.075,1.075,0,0,0-.352.333A.79.79,0,0,0,.1-7.756a.832.832,0,0,0,.139.472,1.6,1.6,0,0,0,.4.4,4.2,4.2,0,0,0,.623.366q.366.179.828.37a9.222,9.222,0,0,1,1.132.56,4.023,4.023,0,0,1,.861.67,2.611,2.611,0,0,1,.549.853,3.015,3.015,0,0,1,.19,1.117,2.992,2.992,0,0,1-.333,1.476,2.706,2.706,0,0,1-.9.967A3.922,3.922,0,0,1,2.245.022a7.683,7.683,0,0,1-1.6.161A8.9,8.9,0,0,1-1,.037,4.964,4.964,0,0,1-2.351-.4ZM14.066-8.577h-3V0H8.7V-8.577H5.716V-10.5h8.35Z",
    transform: "translate(821.805 476)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17879",
    "data-name": "Group 17879",
    transform: "translate(-13095 -13331.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-user-single-10",
    "data-name": "interface-user-single",
    transform: "translate(787.181 382.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262-10",
    "data-name": "Ellipse 262",
    cx: 13.759,
    cy: 13.759,
    r: 13.759,
    transform: "translate(13.224 0.5)",
    fill: "#0782c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569-10",
    "data-name": "Path 10569",
    d: "M53.146,28.077a27.476,27.476,0,0,0-52.326,0Z",
    transform: "translate(0 27.459)",
    fill: "#0782c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17495-10",
    "data-name": "Group 17495",
    transform: "translate(-7.805 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1871-9",
    "data-name": "Rectangle 1871",
    transform: "translate(749.805 448)",
    fill: "#0782c6",
    stroke: "#001a38",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 42,
    rx: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 141,
    height: 39,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10921",
    "data-name": "Path 10921",
    d: "M-48.2,0h-2.717l-1.633-2.7q-.183-.308-.352-.549a3.052,3.052,0,0,0-.341-.414,1.354,1.354,0,0,0-.359-.264.911.911,0,0,0-.406-.092h-.637V0h-2.366V-10.5h3.75q3.823,0,3.823,2.856a2.958,2.958,0,0,1-.168,1.014,2.818,2.818,0,0,1-.476.839,3.018,3.018,0,0,1-.743.645,3.834,3.834,0,0,1-.97.425v.029a1.505,1.505,0,0,1,.454.238,3.252,3.252,0,0,1,.425.385,5.365,5.365,0,0,1,.392.472q.187.253.341.494Zm-6.445-8.73v2.922h1.025A1.7,1.7,0,0,0-52.4-6.248a1.467,1.467,0,0,0,.469-1.106q0-1.377-1.648-1.377Zm16.139,4.182q0,4.731-4.409,4.731-4.277,0-4.277-4.622V-10.5h2.373v6.094q0,2.549,1.992,2.549,1.956,0,1.956-2.461V-10.5h2.366ZM-26.625,0h-2.388l-4.329-6.6a9.543,9.543,0,0,1-.527-.872H-33.9q.059.557.059,1.7V0h-2.234V-10.5h2.549l4.167,6.394q.286.432.527.857h.029a11.23,11.23,0,0,1-.059-1.443V-10.5h2.234Zm12,0h-2.388l-4.329-6.6a9.543,9.543,0,0,1-.527-.872H-21.9q.059.557.059,1.7V0h-2.234V-10.5h2.549l4.167,6.394q.286.432.527.857h.029a11.23,11.23,0,0,1-.059-1.443V-10.5h2.234Zm4.918,0h-2.366V-10.5h2.366ZM2.28,0H-.108L-4.437-6.6a9.543,9.543,0,0,1-.527-.872h-.029q.059.557.059,1.7V0H-7.169V-10.5H-4.62L-.452-4.109q.286.432.527.857H.1A11.23,11.23,0,0,1,.046-4.695V-10.5H2.28ZM13.453-.7A7.559,7.559,0,0,1,9.629.183a5.529,5.529,0,0,1-4-1.4A5.1,5.1,0,0,1,4.173-5.083a5.394,5.394,0,0,1,1.6-4.036,5.817,5.817,0,0,1,4.248-1.56,8.629,8.629,0,0,1,2.944.461V-8a5.852,5.852,0,0,0-2.974-.7,3.192,3.192,0,0,0-2.4.956,3.511,3.511,0,0,0-.927,2.552,3.522,3.522,0,0,0,.831,2.5A2.93,2.93,0,0,0,9.739-1.8a3.125,3.125,0,0,0,1.348-.242V-4.094h-2.1v-1.89h4.468Zm6.482.7V-10.5h3.823a4.774,4.774,0,0,1,2.7.645,2.073,2.073,0,0,1,.945,1.816,2.15,2.15,0,0,1-.575,1.487,3.021,3.021,0,0,1-1.469.886v.029a2.91,2.91,0,0,1,1.791.828,2.315,2.315,0,0,1,.67,1.677A2.8,2.8,0,0,1,26.79-.846,4.321,4.321,0,0,1,23.97,0ZM22.3-8.76v2.49h1.04a1.733,1.733,0,0,0,1.154-.355,1.211,1.211,0,0,0,.421-.978q0-1.157-1.729-1.157Zm0,4.248v2.769h1.282a1.973,1.973,0,0,0,1.285-.381,1.272,1.272,0,0,0,.465-1.04,1.187,1.187,0,0,0-.458-.989A2.025,2.025,0,0,0,23.6-4.512ZM38.937,0H36.359l-.747-2.336H31.876L31.137,0H28.573L32.4-10.5H35.2ZM35.07-4.153l-1.128-3.53a4.6,4.6,0,0,1-.176-.945h-.059a4.006,4.006,0,0,1-.183.916l-1.143,3.56ZM47.7-.374a6.926,6.926,0,0,1-3,.557,5.062,5.062,0,0,1-3.8-1.421,5.194,5.194,0,0,1-1.384-3.787,5.549,5.549,0,0,1,1.556-4.087,5.444,5.444,0,0,1,4.039-1.567,7.554,7.554,0,0,1,2.593.388v2.278a4.594,4.594,0,0,0-2.4-.63,3.187,3.187,0,0,0-2.388.93A3.451,3.451,0,0,0,42-5.193a3.385,3.385,0,0,0,.857,2.428,3.027,3.027,0,0,0,2.307.9A4.921,4.921,0,0,0,47.7-2.534ZM58.412,0H55.423L52.362-4.563a4.374,4.374,0,0,1-.278-.579h-.037V0H49.681V-10.5h2.366v4.966h.037q.088-.205.293-.586l2.9-4.38H58.1l-3.662,5.01Z",
    transform: "translate(821.805 476)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameFormation);
export default __webpack_public_path__ + "static/media/game-formation.db2dd52dca788007bdb86daebe0f9f3e.svg";
export { ForwardRef as ReactComponent };